const [TEMPORARY_NODE_WIDTH, TEMPORARY_NODE_HEIGHT] = [480, 128] as const;

export { TEMPORARY_NODE_HEIGHT, TEMPORARY_NODE_WIDTH };

export const TEMPORARY_NODE_ID_PREFIX = 'LINEAGE_FLOW_TEMPORARY_NODE';
